import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { getTemplateListByType } from '../../states/templates/selectors';
import { selectPaymentTemplate, editPaymentTemplate } from '../../states/templates/actions';

const mapState = (state, props) => ({
	templates: getTemplateListByType(state, props.paymentType),
});

const mapDispatch = (dispatch) => ({
	handleSelectTemplate: (id) => dispatch(selectPaymentTemplate(id)),
	handleEditTemplate: (id, name) => dispatch(editPaymentTemplate(id, name)),
});

const TemplateList = ({ templates, handleSelectTemplate, handleEditTemplate }) => (
	<div>
		{templates.map(({ id, name }) => (
			<div key={id} className="template-row" data-test-id="payment-template-row">
				<div>
					<Button onClick={() => handleSelectTemplate(id)} width="flush">
						<Icon iconType="PageOutlineLarge" className="c-a-button__icon" direction="left" />
						{name}
					</Button>
				</div>
				<div className="edit-section" data-test-id="payment-template-row-edit">
					<Button onClick={() => handleEditTemplate(id)} width="flush" size="xs">
						edit
					</Button>
				</div>
			</div>
		))}
	</div>
);

TemplateList.propTypes = {
	templates: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			name: PropTypes.string.isRequired,
		})
	).isRequired,
	handleSelectTemplate: PropTypes.func,
	handleEditTemplate: PropTypes.func,
};

export default connect(mapState, mapDispatch)(TemplateList);
export { TemplateList };
